// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Mail, Lock, Scan, Activity, Sun, Moon , Eye, EyeOff } from "lucide-react";
// import { motion } from "framer-motion";
// import api from "../login/apilogin";

// const LoginPage = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
 
//   const toggleShowPassword = () => {
//     setShowPassword(prev => !prev);
//   };
//   // Initialize theme from localStorage or prefer-color-scheme
//   useEffect(() => {
//     const savedTheme = localStorage.getItem("theme");
//     const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    
//     if (savedTheme) {
//       setIsDarkMode(savedTheme === "dark");
//     } else {
//       setIsDarkMode(prefersDark);
//     }
//   }, []);

//   // Apply theme changes
//   useEffect(() => {
//     if (isDarkMode) {
//       document.documentElement.classList.add("dark");
//       localStorage.setItem("theme", "dark");
//     } else {
//       document.documentElement.classList.remove("dark");
//       localStorage.setItem("theme", "light");
//     }
//   }, [isDarkMode]);

//   const toggleTheme = () => {
//     setIsDarkMode(!isDarkMode);
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       const response = await api.post("/login/", {
//         username: email,
//         password: password,
//       });

//       if (response.data.success) {
//         localStorage.setItem(
//           "user",
//           JSON.stringify({
//             user: {
//               first_name: response.data.first_name,
//               last_name: response.data.last_name,
//               username: response.data.username,
//               group: response.data.group,
//               user_id: response.data.user_id
//             },
//             dashboard: response.data.dashboard
//           })
//         );
//         navigate(response.data.dashboard);
//       } else {
//         setError("Login failed");
//       }
//     } catch (err) {
//       setError(err.response?.data?.error || "Something went wrong");
//     }
//     setLoading(false);
//   };

//   // Animated Particles Component
//   const FloatingParticles = () => (
//     <>
//       {[...Array(20)].map((_, i) => (
//         <motion.div
//           key={i}
//           className={`absolute w-1 h-1 rounded-full ${
//             isDarkMode ? "bg-red-500/30" : "bg-red-400/40"
//           }`}
//           style={{
//             left: `${Math.random() * 100}%`,
//             top: `${Math.random() * 100}%`,
//           }}
//           animate={{
//             y: [0, -30, 0],
//             x: [0, Math.random() * 20 - 10, 0],
//             opacity: [0.2, 0.8, 0.2],
//             scale: [1, 1.5, 1],
//           }}
//           transition={{
//             duration: 3 + Math.random() * 2,
//             repeat: Infinity,
//             delay: Math.random() * 2,
//             ease: "easeInOut",
//           }}
//         />
//       ))}
//     </>
//   );

//   // Theme-based styles
//   const backgroundStyles = isDarkMode 
//     ? "bg-gradient-to-br from-gray-900 via-black to-gray-800"
//     : "bg-gradient-to-br from-blue-50 via-white to-gray-100";

//   const cardStyles = isDarkMode 
//     ? "bg-gray-900 border-gray-700 text-white"
//     : "bg-white border-gray-200 text-gray-800";

//   const inputStyles = isDarkMode
//     ? "bg-gray-800 border-gray-700 text-white placeholder-gray-400 focus:border-red-500 focus:ring-red-500"
//     : "bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-red-400 focus:ring-red-400";

//   const errorStyles = isDarkMode
//     ? "bg-red-900/50 border-red-800 text-red-300"
//     : "bg-red-50 border-red-200 text-red-700";

//   const footerTextStyles = isDarkMode
//     ? "text-gray-400"
//     : "text-gray-600";

//   const subtitleStyles = isDarkMode
//     ? "text-gray-400"
//     : "text-gray-600";

//   return (
//     <div className={`flex items-center justify-center min-h-screen relative overflow-hidden transition-colors duration-500 ${backgroundStyles}`}>
//       {/* Floating Particles */}
//       <FloatingParticles />

//       {/* Animated Gradient Overlay */}
//       <motion.div
//         className={`absolute inset-0 ${
//           isDarkMode
//             ? "bg-[radial-gradient(circle_at_50%_50%,_rgba(220,38,38,0.03),transparent_50%)]"
//             : "bg-[radial-gradient(circle_at_50%_50%,_rgba(220,38,38,0.05),transparent_50%)]"
//         }`}
//         animate={{
//           scale: [1, 1.2, 1],
//           opacity: [0.3, 0.5, 0.3],
//         }}
//         transition={{
//           duration: 8,
//           repeat: Infinity,
//           ease: "easeInOut",
//         }}
//       />

//       {/* Theme-based Background Elements */}
//       {isDarkMode ? (
//         <>
//           {/* Dark Mode Background */}
//           <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gray-800 via-black to-black"></div>
          
//           {/* Animated X-ray Scan Lines - Dark */}
//           <motion.div
//             className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:64px_64px]"
//             animate={{ y: [0, 64, 0] }}
//             transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
//           />
          
//           {/* Pulsing Heartbeat Animation - Dark */}
//           <motion.div
//             className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 border-2 border-red-500 rounded-full opacity-10"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.1, 0.05, 0.1] }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//         </>
//       ) : (
//         <>
//           {/* Light Mode Background */}
//           <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-100 via-white to-gray-200"></div>
          
//           {/* Animated Scan Lines - Light */}
//           <motion.div
//             className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.02)_1px,transparent_1px)] bg-[size:64px_64px]"
//             animate={{ y: [0, 64, 0] }}
//             transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
//           />
          
//           {/* Pulsing Animation - Light */}
//           <motion.div
//             className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 border-2 border-red-400 rounded-full opacity-20"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.1, 0.05, 0.1] }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//         </>
//       )}

//       {/* Medical Monitor Glow */}
//       <motion.div
//         className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full blur-3xl ${
//           isDarkMode 
//             ? "bg-red-500 opacity-5" 
//             : "bg-red-400 opacity-10"
//         }`}
//         animate={{ opacity: [0.05, 0.08, 0.05] }}
//         transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
//       />

//       {/* Theme Toggle Button */}
//       <motion.button
//         onClick={toggleTheme}
//         className={`absolute top-6 right-6 z-20 p-3 rounded-full backdrop-blur-md border transition-all duration-300 ${
//           isDarkMode
//             ? "bg-gray-800/80 border-gray-700 text-yellow-400 hover:bg-gray-700/80"
//             : "bg-white/80 border-gray-300 text-gray-700 hover:bg-white"
//         }`}
//         whileHover={{ scale: 1.1 }}
//         whileTap={{ scale: 0.9 }}
//         title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
//       >
//         {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
//       </motion.button>

//       {/* Cartoon Character Welcome */}
//       <motion.div
//         initial={{ opacity: 0, x: 100, scale: 0.8 }}
//         animate={{ opacity: 1, x: 0, scale: 1 }}
//         transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
//         className={`absolute right-10 top-1/2 transform -translate-y-1/2 z-10 hidden lg:block ${
//           isDarkMode ? "text-white" : "text-gray-800"
//         }`}
//       >
//         {/* Speech Bubble */}
//         <motion.div
//           className={`relative mb-4 p-4 rounded-2xl max-w-xs ${
//             isDarkMode 
//               ? "bg-gray-800 border border-gray-700" 
//               : "bg-white border border-gray-200 shadow-lg"
//           }`}
//           animate={{ y: [0, -5, 0] }}
//           transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
//         >
//           <p className={`text-sm font-medium ${
//             isDarkMode ? "text-white" : "text-gray-800"
//           }`}>
//             Welcome to <span className="text-red-500 font-bold">U4RAD</span> Reporting Platform! 👋
//           </p>
//           <p className={`text-xs mt-1 ${
//             isDarkMode ? "text-gray-400" : "text-gray-600"
//           }`}>
//             Ready to dive into your reports?
//           </p>
          
//           {/* Speech bubble tail */}
//           <div className={`absolute -bottom-2 right-6 w-4 h-4 transform rotate-45 ${
//             isDarkMode ? "bg-gray-800 border-r border-b border-gray-700" : "bg-white border-r border-b border-gray-200"
//           }`}></div>
//         </motion.div>

//         {/* Cartoon Doctor Character */}
        

     
//       </motion.div>

//       {/* Login Card - Medical Monitor Style */}
//       <motion.div
//         initial={{ opacity: 0, scale: 0.9 }}
//         animate={{ opacity: 1, scale: 1 }}
//         transition={{ duration: 0.8, ease: "easeOut" }}
//         className={`relative z-10 border rounded-xl shadow-2xl w-full max-w-md overflow-hidden backdrop-blur-md ${cardStyles}`}
//         style={{
//           boxShadow: isDarkMode 
//             ? "0 0 40px rgba(220, 38, 38, 0.1), 0 0 80px rgba(220, 38, 38, 0.05)"
//             : "0 0 40px rgba(220, 38, 38, 0.1), 0 0 60px rgba(220, 38, 38, 0.05)"
//         }}
//       >
//         {/* Monitor Top Bar */}
       
       

//         {/* Monitor Content */}
//         <div className={`p-8 bg-gradient-to-b ${
//           isDarkMode ? "from-gray-900 to-black" : "from-white to-gray-50"
//         }`}>
//           {/* Header with Medical Icons */}
//           <motion.div 
//             className="flex flex-col items-center mb-8"
//             initial={{ y: -20 }}
//             animate={{ y: 0 }}
//             transition={{ delay: 0.2 }}
//           >
            
            
//              <motion.img
//               src="https://u4rad.com/static/media/Logo.c9920d154c922ea9e355.png"
//               alt="U4RAD Logo"
//               className={`h-20 w-auto mb-4 rounded-lg p-2 transition-all duration-300 ${
//                 isDarkMode ? "bg-white" : ""
//               }`}
//               animate={{
//                 y: [0, -5, 0],
//                 scale: [1, 1.05, 1],
//               }}
//               transition={{
//                 duration: 3,
//                 repeat: Infinity,
//                 ease: "easeInOut",
//               }}
//             />
            
//             <h2 className={`text-2xl font-bold text-center mb-2 ${
//               isDarkMode ? "text-white" : "text-gray-900"
//             }`}>
//               Reporting Platform! 
//             </h2>
//             <p className={`text-center text-sm ${subtitleStyles}`}>
//               Secure Access to Radiology Reporting
//             </p>
//           </motion.div>

//           <form onSubmit={handleLogin} className="space-y-6">
//             {/* Email Input */}
//             <motion.div
//               className="relative group"
//               initial={{ x: -50, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ delay: 0.3, duration: 0.5 }}
//             >
//               <motion.div 
//                 className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
//                 animate={{
//                   scale: [1, 1.1, 1],
//                 }}
//                 transition={{
//                   duration: 2,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//               >
//                 <Mail className={`group-focus-within:text-red-500 transition-colors ${
//                   isDarkMode ? "text-gray-500" : "text-gray-400"
//                 }`} size={20} />
//               </motion.div>
//               <input
//                 type="email"
//                 placeholder="Medical ID / Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className={`w-full border rounded-lg pl-10 pr-4 py-3 focus:outline-none focus:ring-2 transition-all duration-300 ${inputStyles}`}
//               />
//               <motion.div
//                 className={`absolute inset-0 rounded-lg pointer-events-none ${
//                   isDarkMode ? "bg-red-500/5" : "bg-red-400/10"
//                 }`}
//                 initial={{ opacity: 0 }}
//                 whileFocus={{ opacity: 1 }}
//               />
//             </motion.div>

//             {/* Password Input */}
// <motion.div
//   className="relative group"
//   initial={{ x: -50, opacity: 0 }}
//   animate={{ x: 0, opacity: 1 }}
//   transition={{ delay: 0.4, duration: 0.5 }}
// >
//   <motion.div 
//     className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
//     animate={{
//       rotate: [0, -5, 5, 0],
//     }}
//     transition={{
//       duration: 3,
//       repeat: Infinity,
//       ease: "easeInOut",
//     }}
//   >
//     <Lock className={`group-focus-within:text-red-500 transition-colors ${
//       isDarkMode ? "text-gray-500" : "text-gray-400"
//     }`} size={20} />
//   </motion.div>

//   <input
//     type={showPassword ? "text" : "password"}
//     placeholder="Access Code"
//     value={password}
//     onChange={(e) => setPassword(e.target.value)}
//     className={`w-full border rounded-lg pl-10 pr-12 py-3 focus:outline-none focus:ring-2 transition-all duration-300 ${inputStyles}`}
//     aria-label="Access Code"
//   />

//   {/* right-side eye button */}
//   <button
//     type="button"
//     onClick={toggleShowPassword}
//     className={`absolute inset-y-0 right-2 flex items-center px-2 rounded focus:outline-none ${
//       isDarkMode ? "text-gray-300 hover:text-white" : "text-gray-600 hover:text-gray-800"
//     }`}
//     aria-label={showPassword ? "Hide password" : "Show password"}
//     title={showPassword ? "Hide password" : "Show password"}
//   >
//     {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//   </button>

//   <motion.div
//     className={`absolute inset-0 rounded-lg pointer-events-none ${
//       isDarkMode ? "bg-red-500/5" : "bg-red-400/10"
//     }`}
//     initial={{ opacity: 0 }}
//     whileFocus={{ opacity: 1 }}
//   />
// </motion.div>


//             {/* Error Message */}
//             {error && (
//               <motion.div
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 className={`border rounded-lg p-3 ${errorStyles}`}
//               >
//                 <p className="text-sm font-medium text-center">{error}</p>
//               </motion.div>
//             )}

//             {/* Login Button */}
//             <motion.button
//               type="submit"
//               className={`w-full text-white py-3 rounded-lg font-semibold shadow-lg transition-all relative overflow-hidden group ${
//                 isDarkMode
//                   ? "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
//                   : "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700"
//               }`}
//               initial={{ y: 20, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.5, duration: 0.5 }}
//               whileHover={{ 
//                 scale: 1.03,
//                 boxShadow: isDarkMode 
//                   ? "0 10px 40px rgba(220, 38, 38, 0.4)" 
//                   : "0 10px 40px rgba(220, 38, 38, 0.3)"
//               }}
//               whileTap={{ scale: 0.97 }}
//             >
//               {/* Shimmer Effect */}
//               <motion.div
//                 className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12"
//                 animate={{
//                   x: ["-200%", "200%"],
//                 }}
//                 transition={{
//                   duration: 2,
//                   repeat: Infinity,
//                   repeatDelay: 1,
//                   ease: "easeInOut",
//                 }}
//               />
              
//               {/* Pulse Effect */}
//               <motion.div
//                 className="absolute inset-0 bg-white/10 rounded-lg"
//                 animate={{
//                   scale: [1, 1.05, 1],
//                   opacity: [0.5, 0.8, 0.5],
//                 }}
//                 transition={{
//                   duration: 2,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//               />
              
//              <span className="relative z-10 flex items-center justify-center">
//   {loading ? (
//     <motion.div
//       className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
//     />
//   ) : (
//     <motion.span
//       animate={{
//         letterSpacing: ["0em", "0.05em", "0em"],
//       }}
//       transition={{
//         duration: 3,
//         repeat: Infinity,
//         ease: "easeInOut",
//       }}
//     >
//       ACCESS SYSTEM
//     </motion.span>
//   )}
// </span>

//             </motion.button>
//           </form>

//           {/* Footer Links */}
//           <div className={`mt-8 pt-6 border-t ${
//             isDarkMode ? "border-gray-800" : "border-gray-200"
//           }`}>
//             <div className={`text-center text-sm ${footerTextStyles}`}>
//               <p className="mb-2">
//                 Forgot your credentials?{" "}
//                 <span className={`cursor-pointer transition-colors ${
//                   isDarkMode ? "text-red-400 hover:text-red-300" : "text-red-500 hover:text-red-600"
//                 }`}>
//                   Request reset
//                 </span>
//               </p>
//               <p className={`text-xs ${
//                 isDarkMode ? "text-gray-500" : "text-gray-400"
//               }`}>
//                 Authorized medical personnel only
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Monitor Bottom Glow */}
//         <div className={`h-1 bg-gradient-to-r from-transparent ${
//           isDarkMode ? "via-red-500" : "via-red-400"
//         } to-transparent opacity-30`}></div>
//       </motion.div>

//       {/* Floating Medical Elements */}
//       <motion.div
//         className={`absolute top-20 left-20 ${
//           isDarkMode ? "text-white/5" : "text-gray-400/20"
//         }`}
//         animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }}
//         transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//       >
//         ⚕️
//       </motion.div>
//       <motion.div
//         className={`absolute bottom-20 right-20 ${
//           isDarkMode ? "text-white/5" : "text-gray-400/20"
//         }`}
//         animate={{ y: [0, 20, 0], rotate: [0, -5, 0] }}
//         transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//       >
//         🩺
//       </motion.div>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, Sun, Moon, Eye, EyeOff, ScanFace, X, Scan } from "lucide-react";
import api from "../login/apilogin";

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraError, setCameraError] = useState("");
  const [scanLine, setScanLine] = useState(false);
  const videoRef = React.useRef(null);
  const canvasRef = React.useRef(null);

  const toggleShowPassword = () => setShowPassword((p) => !p);

  // theme load
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    setIsDarkMode(savedTheme ? savedTheme === "dark" : prefersDark);
  }, []);

  // theme apply
  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkMode);
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  useEffect(() => {
    if (!cameraOpen) return;
    const startVideo = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
        setTimeout(() => setScanLine(true), 600);
      } catch (err) {
        console.error("Camera error:", err);
        setError("Camera access denied");
      }
    };
    startVideo();
  }, [cameraOpen]);

  useEffect(() => {
    if (!cameraOpen) return;
    const interval = setInterval(() => {
      if (!loading) {
        captureFace();
      }
    }, 2500);
    return () => clearInterval(interval);
  }, [cameraOpen]);

  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  const startCamera = () => {
    setCameraOpen(true);
    setCameraError("");
  };

  const stopCamera = () => {
    setScanLine(false);
    const stream = videoRef.current?.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  };

  const captureFace = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    if (video.videoWidth === 0) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);
    const image = canvas.toDataURL("image/jpeg");
    verifyFace(image);
  };

  const verifyFace = async (image) => {
    setLoading(true);
    setCameraError("");
    try {
      const response = await api.post("/verify-face/", { image });
      if (response.data.success) {
        stopCamera();
        localStorage.setItem(
          "user",
          JSON.stringify({
            user: {
              first_name: response.data.first_name,
              last_name: response.data.last_name,
              username: response.data.username,
              group: response.data.group,
              user_id: response.data.user_id,
            },
            dashboard: response.data.dashboard,
          })
        );
        navigate(response.data.dashboard);
      } else {
        setCameraError(response.data.message || "Face not recognized");
      }
    } catch (err) {
      const msg = err.response?.data?.error;
      if (msg === "No face detected") setCameraError("No face detected — please look at the camera.");
      else if (msg === "Face not registered") setCameraError("Face not registered in the system.");
      else setCameraError("Face authentication failed. Please try again.");
    }
    setLoading(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await api.post("/login/", {
        username: email,
        password: password,
      });
      if (response.data.success) {
        localStorage.setItem(
          "user",
          JSON.stringify({
            user: {
              first_name: response.data.first_name,
              last_name: response.data.last_name,
              username: response.data.username,
              group: response.data.group,
              user_id: response.data.user_id,
            },
            dashboard: response.data.dashboard,
          })
        );
        navigate(response.data.dashboard);
      } else {
        setError("Login failed");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    }
    setLoading(false);
  };

  const backgroundStyles = isDarkMode
    ? "bg-gray-900"
    : "bg-gradient-to-br from-blue-50 via-white to-gray-100";

  const cardStyles = isDarkMode
    ? "bg-gray-900 border-gray-700 text-white"
    : "bg-white border-gray-200 text-gray-800";

  const inputStyles = isDarkMode
    ? "bg-gray-800 border-gray-700 text-white placeholder-gray-400 focus:border-red-500 focus:ring-red-500"
    : "bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-red-400 focus:ring-red-400";

  const errorStyles = isDarkMode
    ? "bg-red-900/50 border-red-800 text-red-300"
    : "bg-red-50 border-red-200 text-red-700";

  const subtitleStyles = isDarkMode ? "text-gray-400" : "text-gray-600";

  return (
    <>
      <style>{`
        /* ── Face Modal Styles ── */
        .face-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.75);
          backdrop-filter: blur(6px);
          z-index: 50;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: overlayIn 0.3s ease both;
        }
        @keyframes overlayIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .face-modal {
          background: ${isDarkMode ? "rgba(15,17,24,0.95)" : "rgba(255,255,255,0.97)"};
          border: 1px solid ${isDarkMode ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.07)"};
          border-radius: 20px;
          overflow: hidden;
          width: 100%;
          max-width: 360px;
          box-shadow: 0 32px 80px rgba(0,0,0,0.4);
          animation: modalIn 0.35s cubic-bezier(0.22, 1, 0.36, 1) both;
        }
        @keyframes modalIn {
          from { opacity: 0; transform: scale(0.94) translateY(16px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }

        .face-modal-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 18px 20px 14px;
          border-bottom: 1px solid ${isDarkMode ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.07)"};
        }
        .face-modal-title {
          font-size: 15px;
          font-weight: 700;
          color: ${isDarkMode ? "#e8eaf0" : "#0d0f14"};
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .face-modal-close {
          width: 30px; height: 30px;
          border-radius: 8px;
          border: none;
          background: ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(245,246,250,0.9)"};
          color: ${isDarkMode ? "#6b7280" : "#5a6070"};
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: all 0.15s;
        }
        .face-modal-close:hover {
          background: ${isDarkMode ? "rgba(231,76,60,0.1)" : "rgba(192,57,43,0.08)"};
          color: #c0392b;
        }

        .face-modal-body { padding: 20px; }

        .video-container {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          background: #000;
          aspect-ratio: 4/3;
          margin-bottom: 16px;
        }
        .face-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        /* Corner bracket frame */
        .face-frame {
          position: absolute;
          inset: 12px;
          pointer-events: none;
        }
        .face-frame::before, .face-frame::after,
        .face-frame-inner::before, .face-frame-inner::after {
          content: '';
          position: absolute;
          width: 22px; height: 22px;
          border-color: rgba(59,130,246,0.9);
          border-style: solid;
        }
        .face-frame::before { top: 0; left: 0; border-width: 2.5px 0 0 2.5px; border-radius: 2px 0 0 0; }
        .face-frame::after  { top: 0; right: 0; border-width: 2.5px 2.5px 0 0; border-radius: 0 2px 0 0; }
        .face-frame-inner::before { bottom: 0; left: 0; border-width: 0 0 2.5px 2.5px; border-radius: 0 0 0 2px; }
        .face-frame-inner::after  { bottom: 0; right: 0; border-width: 0 2.5px 2.5px 0; border-radius: 0 0 2px 0; }

        /* Animated scan line */
        .scan-line {
          position: absolute;
          left: 8%; right: 8%;
          height: 2px;
          background: linear-gradient(90deg, transparent, rgba(59,130,246,0.9), transparent);
          box-shadow: 0 0 8px rgba(59,130,246,0.6);
          border-radius: 2px;
          animation: scanMove 2.2s ease-in-out infinite;
          opacity: 0;
          transition: opacity 0.5s ease;
        }
        .scan-line.active { opacity: 1; }
        @keyframes scanMove {
          0%   { top: 10%; }
          50%  { top: 85%; }
          100% { top: 10%; }
        }

        /* Pulse status badge */
        .scan-status {
          position: absolute;
          top: 10px; right: 10px;
          display: flex; align-items: center; gap: 6px;
          background: rgba(0,0,0,0.55);
          backdrop-filter: blur(4px);
          border-radius: 20px;
          padding: 5px 10px;
          font-size: 11px;
          color: white;
          font-weight: 500;
        }
        .pulse-dot {
          width: 7px; height: 7px;
          border-radius: 50%;
          background: #3b82f6;
          animation: pulseDot 1.5s ease-in-out infinite;
        }
        .pulse-dot.error { background: #e74c3c; animation: none; }
        @keyframes pulseDot {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.5; transform: scale(0.8); }
        }

        .face-hint {
          text-align: center;
          font-size: 13px;
          color: ${isDarkMode ? "#6b7280" : "#5a6070"};
          margin-bottom: 12px;
          line-height: 1.5;
        }

        .face-error-box {
          background: ${isDarkMode ? "rgba(231,76,60,0.1)" : "rgba(192,57,43,0.08)"};
          border: 1px solid ${isDarkMode ? "rgba(231,76,60,0.25)" : "rgba(192,57,43,0.3)"};
          border-radius: 8px;
          padding: 9px 12px;
          font-size: 13px;
          color: ${isDarkMode ? "#fc8181" : "#c0392b"};
          text-align: center;
          margin-bottom: 12px;
          animation: fadeUpFace 0.3s ease both;
        }
        @keyframes fadeUpFace {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .btn-cancel-face {
          width: 100%;
          padding: 11px;
          border-radius: 8px;
          border: 1px solid ${isDarkMode ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.07)"};
          font-size: 13.5px;
          font-weight: 500;
          cursor: pointer;
          background: ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(245,246,250,0.9)"};
          color: ${isDarkMode ? "#6b7280" : "#5a6070"};
          transition: all 0.2s;
        }
        .btn-cancel-face:hover {
          color: ${isDarkMode ? "#e8eaf0" : "#0d0f14"};
          border-color: #c0392b;
        }
      `}</style>

      <div className={`flex items-center justify-center min-h-screen relative ${backgroundStyles}`}>

        {/* Theme Toggle */}
        <button
          onClick={toggleTheme}
          className={`absolute top-6 right-6 z-20 p-3 rounded-full border ${
            isDarkMode
              ? "bg-gray-800 border-gray-700 text-yellow-400"
              : "bg-white border-gray-300 text-gray-700"
          }`}
        >
          {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>

        {/* Login Card */}
        <div className={`relative z-10 border rounded-xl shadow-2xl w-full max-w-md ${cardStyles}`}>
          <div className={`p-8 ${isDarkMode ? "from-gray-900 to-black" : "from-white to-gray-50"}`}>

            {/* Logo */}
            <div className="flex flex-col items-center mb-8">
              <img
                src="https://u4rad.com/static/media/Logo.c9920d154c922ea9e355.png"
                alt="U4RAD Logo"
                className={`h-20 w-auto mb-4 rounded-lg p-2 ${isDarkMode ? "bg-white" : ""}`}
              />
              <h2 className="text-2xl font-bold text-center mb-2">Reporting Platform!</h2>
              <p className={`text-center text-sm ${subtitleStyles}`}>
                Secure Access to Radiology Reporting
              </p>
            </div>

            <form onSubmit={handleLogin} className="space-y-6">

              {/* Email Input */}
              <div className="relative">
                <Mail
                  className={`absolute inset-y-0 left-3 my-auto ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
                  size={20}
                />
                <input
                  type="email"
                  placeholder="Medical ID / Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`w-full border rounded-lg pl-10 pr-4 py-3 ${inputStyles}`}
                />
              </div>

              {/* Password Input */}
              <div className="relative">
                <Lock
                  className={`absolute inset-y-0 left-3 my-auto ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
                  size={20}
                />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Access Code"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`w-full border rounded-lg pl-10 pr-12 py-3 ${inputStyles}`}
                />
                <button
                  type="button"
                  onClick={toggleShowPassword}
                  className={`absolute inset-y-0 right-2 flex items-center ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>

              {/* Error */}
              {error && (
                <div className={`border rounded-lg p-3 ${errorStyles}`}>{error}</div>
              )}

              {/* Login Button */}
              <button
                type="submit"
                className={`w-full text-white py-3 rounded-lg font-semibold ${
                  isDarkMode ? "bg-red-700 hover:bg-red-800" : "bg-red-500 hover:bg-red-600"
                }`}
              >
                {loading ? "Logging in..." : "Login"}
              </button>

               {/* OR Divider */}
              <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "18px 0" }}>
                <div style={{ flex: 1, height: 1, background: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)" }} />
                <span style={{ fontSize: 12, color: isDarkMode ? "#6b7280" : "#9ca3af", fontWeight: 500 }}>or</span>
                <div style={{ flex: 1, height: 1, background: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)" }} />
              </div>

              {/* Face Login Button */}
              <button
                type="button"
                onClick={startCamera}
                className="w-full mt-3 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2"
              >
                <ScanFace size={18} strokeWidth={1.8} />
                Login with Face Recognition
              </button>

            </form>
          </div>
        </div>

        {/* ── Face Recognition Modal ── */}
        {cameraOpen && (
          <div className="face-overlay">
            <div className="face-modal">

              <div className="face-modal-header">
                <div className="face-modal-title">
                  <Scan size={16} strokeWidth={2} style={{ color: "#1a73e8" }} />
                  Face Recognition
                </div>
                <button
                  className="face-modal-close"
                  onClick={() => { stopCamera(); setCameraOpen(false); }}
                >
                  <X size={15} strokeWidth={2} />
                </button>
              </div>

              <div className="face-modal-body">
                <div className="video-container">
                  <video ref={videoRef} autoPlay playsInline className="face-video" />
                  <canvas ref={canvasRef} style={{ display: "none" }} />

                  {/* Corner bracket frame */}
                  <div className="face-frame">
                    <div className="face-frame-inner" />
                  </div>

                  {/* Animated scan line */}
                  <div className={`scan-line${scanLine ? " active" : ""}`} />

                  {/* Status badge */}
                  <div className="scan-status">
                    <div className={`pulse-dot${cameraError ? " error" : ""}`} />
                    {loading ? "Verifying…" : cameraError ? "Retry" : "Scanning"}
                  </div>
                </div>

                <p className="face-hint">Position your face within the frame and hold still.</p>

                {cameraError && (
                  <div className="face-error-box">{cameraError}</div>
                )}

                <button
                  className="btn-cancel-face"
                  onClick={() => { stopCamera(); setCameraOpen(false); }}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default LoginPage;